import upperFirst from 'lodash/upperFirst';

export const ParseError = (error: object, defaultError: string) => {
  const errorMessage =
    Array.isArray(error) && error.length > 0 && error[0].details
      ? error.map((err) => err.details).join(', ')
      : defaultError;
  return upperFirst(errorMessage);
};
